package app.nestbridge.feature.progress.ui

import app.nestbridge.feature.progress.screen.ProgressScreen
import app.nestbridge.feature.progress.screen.ProgressState
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.screen.Screen
import com.slack.circuit.runtime.ui.Ui
import com.slack.circuit.runtime.ui.ui
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
public class ProgressUiFactory : Ui.Factory {
  override fun create(screen: Screen, context: CircuitContext): Ui<*>? = when (screen) {
    ProgressScreen -> ui<ProgressState> { state, modifier -> ProgressUi(state = state, modifier = modifier) }
    else -> null
  }
}
